<template lang="pug">
  validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
    confirm-dialog(
      :value="openApproveDialog"
      :loading="loading"
      @confirm="updateLesson"
      @input="openApproveDialog = false"
      v-slot:body
    )
      strong Тип урока изменен на заочный.

    v-row.mb-5
      v-col(cols=12 md=6)
        v-card.sdo-card.fill-height
          v-card-text
            configuration-lesson(
              v-model="lesson"
            )
      v-col(cols=12 md=6)
        v-card.sdo-card.mb-5.fill-height
          v-card-text
            v-row
              v-col.pa-0(cols=12 :sm="lesson.date_end ? 9 : 12")
                configuration-attachments(
                  v-model="attachments"
                  :lesson-instance="lessonInstance"
                )
    sdo-back-button
    v-btn(
      @click="handleSubmit(saveLesson)"
      :loading="loading"
      color="success"
      rounded
      depressed
    ) {{ lessonInstance ? 'Сохранить' : 'Добавить' }}
</template>

<script>
import { mapGetters } from 'vuex';

import { LESSON_TYPES } from '@/utils/constants';

import ConfigurationLesson from './ConfigurationLesson.vue';
import ConfigurationZoom from './ConfigurationZoom.vue';
import ConfigurationAttachments from './ConfigurationAttachments.vue';
import LessonShortInfo from './LessonShortInfo.vue';

export default {
  name: 'LessonCreateMainForm',
  components: {
    ConfigurationLesson,
    ConfigurationZoom,
    ConfigurationAttachments,

    LessonShortInfo,
  },
  props: {
    lessonInstance: { type: Object, default: null },
  },
  data() {
    return {
      LESSON_TYPES,
      dateStart: null,
      openApproveDialog: false,
      lesson: {
        name: '',
        description: '',
        type: 1,
        date_start: new Date(),
        date_end: '',
        duration: 45,
      },
      attachments: {
        content_links: [],
        content_files: [],
        content_stream: [],
        content_lecture: [],
        content_telegram: [],
      },
      meeting: {
        topic: null,
        duration: 45,
        password: '123456',
        start_time: null,
        //  experimental feature - zoom 1, youtube 2
        meeting_type: 1,
        settings: {
          participant_video: false,
          watermark: false,
          host_video: false,
        },
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData',
      isOrganization: 'auth/isOrganization',
    }),
    duration() {
      return this.lesson.duration;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.lessonInstance) {
        this.$set(this, 'lesson', {
          name: this.lessonInstance.name,
          description: this.lessonInstance.description,
          type: this.lessonInstance.type,
          video_uri: this.lessonInstance.video_uri,
          duration: 45,
          date_start: this.$dp.dateprintDefault(this.lessonInstance.date_start),
          date_end: this.$dp.dateprintDefault(this.lessonInstance.date_end),
        });
        this.$set(this, 'attachments', {
          content_links: this.lessonInstance.content_links || [],
          content_files: this.lessonInstance.content_files || [],
          content_stream: this.lessonInstance.content_stream || [],
          content_lecture: this.lessonInstance.content_lecture || [],
          content_telegram: this.lessonInstance.content_telegram || [],
        });
        if (this.lessonInstance.meeting) {
          this.$set(this, 'meeting', {
            ...this.meeting,
            password: this.lessonInstance.meeting.password,
            topic: this.lessonInstance.meeting.topic,
            start_url: this.lessonInstance.meeting.start_url,
            join_url: this.lessonInstance.meeting.join_url,
            settings: {
              participant_video: this.lessonInstance.meeting.settings_host_video,
              watermark: this.lessonInstance.meeting.settings_watermark,
              host_video: this.lessonInstance.meeting.settings_participant_video,
            },
          });
        }
      }
    },
    getPreparedData() {
      const MEETING_TYPES = {
        immediately: 1,
        scheduled: 2,
      };
      const meetingType = this.lesson.start_immediately
        ? MEETING_TYPES.immediately
        : MEETING_TYPES.scheduled;

      const data = {
        course_unit_id: this.$route.params.unitId,
        ...this.lesson,
        ...this.attachments,
      };
      if (this.lesson.type === LESSON_TYPES.fullTime) {
        if (!this.lesson.start_immediately) {
          data.date_start = this.$dp.dateprintServer(this.lesson.date_start);
          data.date_end = this.$dp.dateprintServer(this.lesson.date_end);
        }
        if (!this.isOrganization) {
          data.meeting = {
            ...this.meeting,
            type: meetingType,
          };
        }
      }
      return data;
    },
    createLesson() {
      this.loading = true;
      const data = this.getPreparedData();
      this.$rHandler(
        this.$api.lessons.createLesson(data),
        () => {
          this.$toasted.success('Урок добавлен', { duration: 2000 });
          this.$router.go(-1);
          this.loading = false;
        },
        () => { this.loading = false; },
        this.$refs.obs,
      );
    },
    updateLesson() {
      this.loading = true;
      const data = this.getPreparedData();
      this.$rHandler(
        this.$api.lessons.updateLesson(this.$route.params.lessonId, data),
        () => {
          this.$toasted.success('Урок обновлен', { duration: 2000 });
          this.loading = false;
        },
        () => { this.loading = false; },
        this.$refs.obs,
      );
    },
    saveLesson() {
      if (this.lessonInstance) {
        if (
          this.lessonInstance.type !== this.lesson.type
          && this.lesson.type === LESSON_TYPES.partTime
        ) {
          this.openApproveDialog = true;
        } else this.updateLesson();
      } else this.createLesson();
    },
  },
};
</script>
